import { createSection, fetchSections, UpdateSection,DeleteSection } from "../../../../../hooks/admin/sections";
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { toast } from "react-toastify";

const SectionManagement = () => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    const [selectedSection, setSelectedSection] = useState(null);

    // Fetch all sections
    const { data: sections, refetch } = useQuery("fetchSections", fetchSections, {
        onError: () => toast.error("Failed to fetch sections"),
    });

    // Mutation for updating a section
    const { mutate: updateSection } = UpdateSection();

    // Handle form submission for create/update
    const onSubmit = async (data) => {
        try {
            // Structure section as a single object to push
            const newSectionEntry = { sectionName: data.sectionName };

            // Check if any section has a non-empty section array
            const matchingSections = sections?.filter(
                (section) => section.section?.length > 0
            );

            if (matchingSections?.length > 0) {
                // Update the first matching section by pushing new sectionName
                await updateSection(
                    { id: sections[0]._id, section: newSectionEntry },
                    {
                        onSuccess: () => {
                            toast.success("Section name added successfully");
                            reset();
                            setSelectedSection(null);
                            refetch();
                        },
                        onError: () => toast.error("Failed to add section name"),
                    }
                );
            } else {
                // Create new section document with the sectionName
                await createSection({ section: [newSectionEntry] }).then(() => {
                    toast.success("Section created successfully");
                    reset();
                    refetch();
                });
            }
        } catch (error) {
            toast.error("An error occurred");
        }
    };

    // Handle section name deletion
    const { mutate: deleteSection } = DeleteSection();

    const handleDelete = async (sectionNameToDelete) => {
        if (window.confirm(`Are you sure you want to delete the section name "${sectionNameToDelete}"?`)) {
            try {
                if (!sections || sections.length === 0) {
                    toast.error("No sections available");
                    return;
                }
                const sectionId = sections[0]._id; // Use first document's _id

                // Update the section document with $pull
                await deleteSection(
                    { id: sectionId, section: sectionNameToDelete },
                    {
                        onSuccess: () => {
                            toast.success("Section name deleted successfully");
                            refetch();
                            if (selectedSection && selectedSection.id === sectionId) {
                                setSelectedSection(null);
                            }
                        },
                        onError: (error) => {
                            console.error("Delete error:", error);
                            toast.error("Failed to delete section name");
                        },
                    }
                );
            } catch (error) {
                console.error("handleDelete error:", error);
                toast.error("An error occurred");
            }
        }
    };

    return (
        <React.Fragment>
            <div className="container user-registe-form w-50">
                <h5 className="mt-4 text-light">Skapa ny område</h5>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="user-register-form">
                        <div className="form-floating mb-5 mt-5">
                            {errors.sectionName && (
                                <p className="ms-1 p-1 error fs-6" role="alert">
                                    Please enter a section name
                                </p>
                            )}
                            <input
                                className="form-control"
                                type="text"
                                name="sectionName"
                                placeholder="Section Name"
                                {...register("sectionName", {
                                    required: true,
                                })}
                            />
                            <label htmlFor="floatingInput">Namnet</label>
                        </div>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                            <button className="stats_card" type="submit">
                                <span>Skapa ny område</span>
                            </button>
                        </div>
                    </div>
                </form>

                {/* List of sections */}
                <div className="mt-5">
                    {sections && sections.length > 0 ? (
                        <ul className="list-group">
                            {sections.map((section) =>
                                section.section?.map((entry, index) => (
                                    <li
                                        key={`${section.id}-${index}`}
                                        className="list-group-item d-flex justify-content-between align-items-center"
                                    >
                                        <span>{entry.sectionName || "Unnamed"}</span>
                                        <div>
                                            <button
                                                className="btn btn-sm btn-danger"
                                                onClick={() => handleDelete(entry.sectionName)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </li>
                                ))
                            )}
                        </ul>
                    ) : (
                        <p className="text-light">Inga område tillgängliga</p>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default SectionManagement;